import { render } from "./two-step-verification-three.vue?vue&type=template&id=6e30c6e9"
import script from "./two-step-verification-three.vue?vue&type=script&lang=js"
export * from "./two-step-verification-three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__